import React, { Component } from "react";

class StopManagingStartReversing extends  Component{
    render()
    {
        return (
            <section className="managing-sec">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="managing-inner">
                            <div className="row no-gutters">
                                <div className="col-md-6">
                                    <div className="image-holder  wow  fadeInLeft" data-wow-duration="1s" data-wow-delay=".1s">
                                        <img data-src="https://res.cloudinary.com/image/upload/v1604991943/NewHome/managing-img-min_euobpg.png" alt="" className="img-fluid lazyload" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-box  wow  fadeInRight" data-wow-duration="1s" data-wow-delay=".1s">
                                        <h2>Stop <br/>
                                            Managing. <br/>
                                            Start Reversing.</h2>
                                        <p>*Guaranteed results in 90 days</p>
                                        {/* <a href="#">When can I be diabetes-free?</a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>  
        )
    }

}
export default StopManagingStartReversing